<p style="font-size: 6rem;
font-weight: 600;
color: #b93131;
margin: 2rem 0rem 2rem 2rem">Error 404! :(</p>
<p style="font-size: 3rem;
font-weight: 600;
color: #000000;
margin: 0rem 0rem 2rem 2rem">Postrecito no encontrado</p>
<a style="font-size: 1.5rem;
font-weight: 600;
font-style: italic;
margin-left: 2rem;" routerLink="/home">Regresa al Inicio</a>
